// data/products.js
const products = [
  {
    id: 1,
    name: "Wireless Headphones",
    description: "High quality sound with noise cancellation.",
    price: 99.99,
    category: "Electronics",
    rating: 4.5,
    image: "https://rukminim2.flixcart.com/image/612/612/xif0q/headphone/e/a/f/-original-imagtc44nk4b3hfg.jpeg?q=70",
  },
  {
    id: 2,
    name: "Smart Watch",
    description: "Track your fitness and notifications on the go.",
    price: 149.99,
    category: "Wearables",
    rating: 4.2,
    image: "https://rukminim2.flixcart.com/image/612/612/xif0q/smartwatch/0/p/n/-original-imaghxg3gfavsrym.jpeg?q=70",
  },
  {
    id: 3,
    name: "Bluetooth Speaker",
    description: "Portable speaker with amazing bass.",
    price: 79.99,
    category: "Electronics",
    rating: 4.8,
    image: "https://rukminim2.flixcart.com/image/612/612/xif0q/speaker/q/0/k/-original-imagrc9huqenzmsf.jpeg?q=70",
  },
];

export default products;
